import { render, staticRenderFns } from "./MainTab.vue?vue&type=template&id=66175673&"
import script from "./MainTab.vue?vue&type=script&lang=js&"
export * from "./MainTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports